import createLogger from './logger';

type PendingSocketEmit = {
	eventType: any;
	data: any;
};

const logger = createLogger('socket');

const pendingSocketEmitQueue: PendingSocketEmit[] = [];

export const enqueueSocketEmit = (eventType: any, data: any) => {
	pendingSocketEmitQueue.push({ eventType, data });
	logger.warn('queue emit', {
		eventType,
		queueLength: pendingSocketEmitQueue.length,
	});
};

export const emitOrQueueSocketEvent = (socketClient: any, socketClientReady: boolean, eventType: any, data: any) => {
	if (socketClient && socketClientReady) {
		logger.log('emit immediately', {
			eventType,
			connected: socketClient.connected,
			id: socketClient.id,
		});
		socketClient.emit(eventType, data);
		return;
	}

	logger.warn('emit deferred', {
		eventType,
		hasClient: Boolean(socketClient),
		socketClientReady,
	});
	enqueueSocketEmit(eventType, data);
};

export const hasPendingSocketEmit = () => pendingSocketEmitQueue.length > 0;

export const drainPendingSocketEmitQueue = () => {
	const queuedEvents = [...pendingSocketEmitQueue];
	pendingSocketEmitQueue.length = 0;
	return queuedEvents;
};

export const clearPendingSocketEmitQueue = () => {
	const count = pendingSocketEmitQueue.length;
	pendingSocketEmitQueue.length = 0;
	if (count > 0) {
		logger.warn('clear queued emits', {
			count,
		});
	}
};
